<template>
  <div
    class="gradient-badge"
    :class="{
      'gradient-badge--empty': !text && !$slots.default,
      [`gradient-badge_theme_${theme}`]: !!theme,
    }"
  >
    <slot>
      {{ text }}
    </slot>
  </div>
</template>

<script setup lang="ts">
import type { TmGradientBadgeTheme } from '@/components/shared/badge/types'

const { theme = 'purple' } = defineProps<{
  text?: string
  theme?: TmGradientBadgeTheme
}>()
</script>

<style lang="scss" scoped>
.gradient-badge {
  display: inline-block;
  padding: 0 7px;
  font-weight: $bold-font;
  vertical-align: middle;
  color: $white;
  border-radius: $border-radius;

  &_theme {
    &_purpleBlue {
      background: linear-gradient(91deg, rgba(170, 65, 207, 0.1) 7.36%, rgba(77, 97, 201, 0.1) 85.2%);
    }
    &_purple {
      background: $gradientPurple;
    }

    &_green {
      background: linear-gradient(90.71deg, #69b33c 7.36%, #5b9536 85.2%);
    }
  }

  &--empty {
    min-height: 10px;
    min-width: 10px;
    padding: 0;
    border-radius: 50%;
  }
}
</style>
